/**
 * Types para o módulo Sales/CRM - Frontend
 */

// Etapas do pipeline
export enum EtapaLead {
  LEAD_CADASTRADO = 'LEAD_CADASTRADO',
  CONTATO_REALIZADO = 'CONTATO_REALIZADO',
  EM_CONTATO = 'EM_CONTATO',
  APRESENTACAO_AGENDADA = 'APRESENTACAO_AGENDADA',
  PROPOSTA_ENVIADA = 'PROPOSTA_ENVIADA',
  PROPOSTA_ACEITA = 'PROPOSTA_ACEITA',
  ONBOARDING = 'ONBOARDING',
  SUCESSO_CLIENTE = 'SUCESSO_CLIENTE',
  COLD_LEAD = 'COLD_LEAD'
}

// Labels das etapas
export const ETAPA_LABELS: Record<EtapaLead, string> = {
  [EtapaLead.LEAD_CADASTRADO]: 'Lead Cadastrado',
  [EtapaLead.CONTATO_REALIZADO]: 'Contato Realizado',
  [EtapaLead.EM_CONTATO]: 'Em Contato',
  [EtapaLead.APRESENTACAO_AGENDADA]: 'Apresentação Agendada',
  [EtapaLead.PROPOSTA_ENVIADA]: 'Proposta Enviada',
  [EtapaLead.PROPOSTA_ACEITA]: 'Proposta Aceita',
  [EtapaLead.ONBOARDING]: 'Onboarding',
  [EtapaLead.SUCESSO_CLIENTE]: 'Sucesso do Cliente',
  [EtapaLead.COLD_LEAD]: 'Cold Lead'
};

// Cores das etapas
export const ETAPA_COLORS: Record<EtapaLead, string> = {
  [EtapaLead.LEAD_CADASTRADO]: '#94a3b8',
  [EtapaLead.CONTATO_REALIZADO]: '#60a5fa',
  [EtapaLead.EM_CONTATO]: '#3b82f6',
  [EtapaLead.APRESENTACAO_AGENDADA]: '#8b5cf6',
  [EtapaLead.PROPOSTA_ENVIADA]: '#a855f7',
  [EtapaLead.PROPOSTA_ACEITA]: '#10b981',
  [EtapaLead.ONBOARDING]: '#f59e0b',
  [EtapaLead.SUCESSO_CLIENTE]: '#22c55e',
  [EtapaLead.COLD_LEAD]: '#64748b'
};

// Interfaces
export interface Vendedor {
  id: number;
  name: string;
  email: string;
}

export interface Origem {
  id: number;
  nome: string;
  created_at: string;
}

export interface Indicador {
  id: number;
  nome: string;
  telefone: string;
  email?: string;
  total_indicacoes: number;
  tem_recorrencia: boolean;
  porcentagem_recorrencia?: number;
  valor_total_recorrencia?: number;
  data_pagamento_recorrencia?: string;
  created_at: string;
}

export interface Lead {
  id: number;
  uuid: string;
  cnpj: string;
  nome_empresa: string;
  telefone: string;
  email: string;
  origem_id?: number;
  is_indicacao: boolean;
  indicador_id?: number;
  vendedor_id: number;
  suporte_id?: number;
  etapa_atual: EtapaLead;
  data_entrada_etapa: string;
  chatconnect_conversation_id?: string;
  created_at: string;
  updated_at: string;
  
  // Relacionamentos
  vendedor?: Vendedor;
  suporte?: Vendedor;
  origem?: Origem;
  indicador?: Indicador;
}

export interface CreateLeadDTO {
  cnpj: string;
  nome_empresa: string;
  telefone: string;
  email: string;
  origem_id?: number;
  origem_nome?: string;
  is_indicacao: boolean;
  indicador_id?: number;
  indicador_nome?: string;
  indicador_telefone?: string;
  vendedor_id: number;
}

export interface KanbanData {
  [key: string]: Lead[];
}

export interface Produto {
  id: number;
  nome: string;
  descricao?: string;
  is_active: boolean;
  created_at: string;
}

export interface Proposta {
  id: number;
  uuid: string;
  lead_id: number;
  valor_mensalidade: number;
  valor_start: number;
  data_validade: string;
  status: 'RASCUNHO' | 'ENVIADA' | 'ACEITA' | 'RECUSADA' | 'EXPIRADA';
  data_envio?: string;
  data_aceite?: string;
  pdf_url?: string;
  webview_url?: string;
  created_at: string;
  
  // Relacionamentos
  lead?: Lead;
  produtos?: Produto[];
}


